import { apiClient } from './apiClient';
import type {
  TcRunDetailResponse,
  TcRunAppraiseeResponse,
  UpdateTcRunRatingsRequest,
  UpdateTcRunNotesForCollatorRequest,
  UpdateTcRunConfidentialNotesRequest,
  UpdateRunningOrderRequest,
} from './types/tcRun.types';

export const tcRunApi = {
  getTcRunDetail: async (tcId: number): Promise<TcRunDetailResponse> => {
    try {
      return await apiClient.get(`/talent-committees/${tcId}/run`).then((res) => res.data);
    } catch (error) {
      console.error('Failed to fetch TC run detail:', error);
      throw error;
    }
  },

  getTcRunAppraiseeDetail: async (tcId: number, appraisalId: number): Promise<TcRunAppraiseeResponse> => {
    try {
      return await apiClient.get(`/talent-committees/${tcId}/run/appraisees/${appraisalId}`).then((res) => res.data);
    } catch (error) {
      console.error('Failed to fetch TC run appraisee detail:', error);
      throw error;
    }
  },

  updateTcRunRatings: async (
    tcId: number,
    appraisalId: number,
    data: UpdateTcRunRatingsRequest
  ): Promise<void> => {
    try {
      await apiClient.put(`/talent-committees/${tcId}/run/appraisees/${appraisalId}/ratings`, data);
    } catch (error) {
      console.error('Failed to update TC run ratings:', error);
      throw error;
    }
  },

  updateTcRunNotesForCollator: async (
    tcId: number,
    appraisalId: number,
    data: UpdateTcRunNotesForCollatorRequest
  ): Promise<void> => {
    try {
      await apiClient.put(`/talent-committees/${tcId}/run/appraisees/${appraisalId}/notes-for-collator`, data);
    } catch (error) {
      console.error('Failed to update TC run notes for collator:', error);
      throw error;
    }
  },

  updateTcRunConfidentialNotes: async (
    tcId: number,
    appraisalId: number,
    data: UpdateTcRunConfidentialNotesRequest
  ): Promise<void> => {
    try {
      await apiClient.put(`/talent-committees/${tcId}/run/appraisees/${appraisalId}/confidential-notes`, data);
    } catch (error) {
      console.error('Failed to update TC run confidential notes:', error);
      throw error;
    }
  },

  approveForDelivery: async (tcId: number, appraisalId: number, rowVersion?: string): Promise<void> => {
    try {
      await apiClient.post(`/talent-committees/${tcId}/run/appraisees/${appraisalId}/approve`, { rowVersion });
    } catch (error) {
      console.error('Failed to approve for delivery:', error);
      throw error;
    }
  },

  returnToCollator: async (tcId: number, appraisalId: number, rowVersion?: string): Promise<void> => {
    try {
      await apiClient.post(`/talent-committees/${tcId}/run/appraisees/${appraisalId}/return`, { rowVersion });
    } catch (error) {
      console.error('Failed to return to collator:', error);
      throw error;
    }
  },

  updateRunningOrder: async (tcId: number, data: UpdateRunningOrderRequest): Promise<void> => {
    try {
      await apiClient.put(`/talent-committees/${tcId}/run/order`, data);
    } catch (error) {
      console.error('Failed to update running order:', error);
      throw error;
    }
  },
};
